import { render } from "./home-grid-text-image.vue?vue&type=template&id=493d5abd&scoped=true"
import script from "./home-grid-text-image.vue?vue&type=script&lang=js"
export * from "./home-grid-text-image.vue?vue&type=script&lang=js"

import "./home-grid-text-image.vue?vue&type=style&index=0&id=493d5abd&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493d5abd"]])

export default __exports__